// A list of all actions in the system.
import { createTypes } from "reduxsauce";

export default createTypes(`
    GET_LOCALE
    GET_USER
    GET_USER_SUCCESS
    GET_USER_FAILURE
    GET_SELLER
    GET_SELLER_SUCCESS
    GET_SELLER_FAILURE
    GET_TNC
    GET_TNC_SUCCESS
    GET_TNC_FAILURE
    ACCEPT_TERMS
    ACCEPT_TERMS_SUCCESS
    ACCEPT_TERMS_FAILURE
    LOGOUT
    LOGOUT_SUCCESS
    LOGOUT_FAILURE
    GET_DASHBOARD
    GET_DASHBOARD_SUCCESS
    GET_DASHBOARD_FAILURE
    GET_ORDERS_V2
    GET_ORDERS_V2_SUCCESS
    GET_ORDERS_V2_FAILURE
    GET_SINGLE_ORDER
    GET_SINGLE_ORDER_SUCCESS
    GET_SINGLE_ORDER_FAILURE
    PRINT_ORDER
    PRINT_ORDER_SUCCESS
    PRINT_ORDER_FAILURE
    POST_PICKUP_V2
    POST_PICKUP_V2_SUCCESS
    POST_PICKUP_V2_FAILURE
    POST_ORDERS_V2
    POST_ORDERS_V2_SUCCESS
    POST_ORDERS_V2_FAILURE
    GET_PRODUCTS
    GET_PRODUCTS_SUCCESS
    GET_PRODUCTS_FAILURE
    GET_PRODUCT_COUNT
    GET_PRODUCT_COUNT_SUCCESS
    GET_PRODUCT_COUNT_FAILURE
    SEARCH_PRODUCTS
    SEARCH_PRODUCTS_SUCCESS
    SEARCH_PRODUCTS_FAILURE
    POST_PRODUCTS
    POST_PRODUCTS_SUCCESS
    POST_PRODUCTS_FAILURE
    EXPORT_OFFERS
    EXPORT_OFFERS_SUCCESS
    EXPORT_OFFERS_FAILURE
    ACTIVATE_OFFERS
    ACTIVATE_OFFERS_SUCCESS
    ACTIVATE_OFFERS_FAILURE
    DELETE_OFFERS
    DELETE_OFFERS_SUCCESS
    DELETE_OFFERS_FAILURE
    IMPORT_OFFERS
    IMPORT_OFFERS_SUCCESS
    IMPORT_OFFERS_FAILURE
    GET_INVOICES
    GET_INVOICES_SUCCESS
    GET_INVOICES_FAILURE
    GET_INVOICES_NOON
    GET_INVOICES_NOON_SUCCESS
    GET_INVOICES_NOON_FAILURE
    GET_CREDIT_NOTES
    GET_CREDIT_NOTES_SUCCESS
    GET_CREDIT_NOTES_FAILURE
    GET_PAYMENTS
    GET_PAYMENTS_SUCCESS
    GET_PAYMENTS_FAILURE
    GET_PAYMENT_DETAILS
    GET_PAYMENT_DETAILS_SUCCESS
    GET_PAYMENT_DETAILS_FAILURE
    GET_FINANCE_VIEW
    GET_FINANCE_VIEW_SUCCESS
    GET_FINANCE_VIEW_FAILURE
    GET_ORDER_VIEW
    GET_ORDER_VIEW_SUCCESS
    GET_ORDER_VIEW_FAILURE
    EXPORT_CREDIT_NOTE
    EXPORT_CREDIT_NOTE_SUCCESS
    EXPORT_CREDIT_NOTE_FAILURE
    EXPORT_INVOICE
    EXPORT_INVOICE_SUCCESS
    EXPORT_INVOICE_FAILURE
    EXPORT_STATEMENTS
    EXPORT_STATEMENTS_SUCCESS
    EXPORT_STATEMENTS_FAILURE
    POST_OUTBOUND
    POST_OUTBOUND_SUCCESS
    POST_OUTBOUND_FAILURE
    GET_REPORTS
    GET_REPORTS_SUCCESS
    GET_REPORTS_FAILURE
    EXPORT_REPORTS
    EXPORT_REPORTS_SUCCESS
    EXPORT_REPORTS_FAILURE
    CLEAR_REPORTS
    GET_WAREHOUSES
    GET_WAREHOUSES_SUCCESS
    GET_WAREHOUSES_FAILURE
    GET_USERS_LIST
    GET_USERS_LIST_SUCCESS
    GET_USERS_LIST_FAILURE
    GET_VAT_INFO
    GET_VAT_INFO_SUCCESS
    GET_VAT_INFO_FAILURE
    GET_ORDERS
    GET_ORDERS_SUCCESS
    GET_ORDERS_FAILURE
    GET_TRANSFERS
    GET_TRANSFERS_SUCCESS
    GET_TRANSFERS_FAILURE
    GET_RESERVED_ORDERS
    GET_RESERVED_ORDERS_SUCCESS
    GET_RESERVED_ORDERS_FAILURE
    POST_ORDERS
    POST_ORDERS_SUCCESS
    POST_ORDERS_FAILURE
    GET_ORDER_COUNT
    GET_ORDER_COUNT_SUCCESS
    GET_ORDER_COUNT_FAILURE
    GET_TRANSFERS_COUNT
    GET_TRANSFERS_COUNT_SUCCESS
    GET_TRANSFERS_COUNT_FAILURE
    GET_FBN_TRANSFERS_COUNT
    GET_FBN_TRANSFERS_COUNT_SUCCESS
    GET_FBN_TRANSFERS_COUNT_FAILURE
    GET_ASN
    GET_ASN_SUCCESS
    GET_ASN_FAILURE
    CLOSE_ASN
    CLOSE_ASN_SUCCESS
    CLOSE_ASN_FAILURE
    OPEN_PICKUP
    OPEN_PICKUP_SUCCESS
    OPEN_PICKUP_FAILURE
    OPEN_FBN_ASN
    OPEN_FBN_ASN_SUCCESS
    OPEN_FBN_ASN_FAILURE
    GET_INITIAL_LINES
    GET_INITIAL_LINES_SUCCESS
    GET_INITIAL_LINES_FAILURE
    IMPORT_FBN_ASN
    IMPORT_FBN_ASN_SUCCESS
    IMPORT_FBN_ASN_FAILURE
    SCHEDULE_ASN
    SCHEDULE_ASN_SUCCESS
    SCHEDULE_ASN_FAILURE
    EXPORT_ELIGIBLE_OFFERS
    EXPORT_ELIGIBLE_OFFERS_SUCCESS
    EXPORT_ELIGIBLE_OFFERS_FAILURE
    GET_PROCESSED_LINES
    GET_PROCESSED_LINES_SUCCESS
    GET_PROCESSED_LINES_FAILURE
    GET_ASN_BATCHES
    GET_ASN_BATCHES_SUCCESS
    GET_ASN_BATCHES_FAILURE
    GET_ASN_BATCHES_IMPORT
    GET_ASN_BATCHES_IMPORT_SUCCESS
    GET_ASN_BATCHES_IMPORT_FAILURE
    GET_OFFER_COUNT
    GET_OFFER_COUNT_SUCCESS
    GET_OFFER_COUNT_FAILURE
    IMPORT_P_SKU_UNIQUE
    IMPORT_P_SKU_UNIQUE_SUCCESS
    IMPORT_P_SKU_UNIQUE_FAILURE
    EXPORT_PSKU
    EXPORT_PSKU_SUCCESS
    EXPORT_PSKU_FAILURE
    GET_IMPORT_LINES
    GET_IMPORT_LINES_SUCCESS
    GET_IMPORT_LINES_FAILURE
    GET_INVENTORY_STOCK
    GET_INVENTORY_STOCK_SUCCESS
    GET_INVENTORY_STOCK_FAILURE
    SYNC_INVENTORY
    SYNC_INVENTORY_SUCCESS
    SYNC_INVENTORY_FAILURE
    GET_NOTIFICATION
    GET_NOTIFICATION_SUCCESS
    GET_NOTIFICATION_FAILURE
    READ_NOTIFICATION
    READ_NOTIFICATION_SUCCESS
    READ_NOTIFICATION_FAILURE

    GET_REQUESTS
    GET_REQUESTS_SUCCESS
    GET_REQUESTS_FAILURE
    CREATE_PICKLIST
    CREATE_PICKLIST_SUCCESS
    CREATE_PICKLIST_FAILURE
    GET_PICKLISTS
    GET_PICKLISTS_SUCCESS
    GET_PICKLISTS_FAILURE
    GET_PICKLIST_ITEMS
    GET_PICKLIST_ITEMS_SUCCESS
    GET_PICKLIST_ITEMS_FAILURE
    MARK_READY_FOR_PICKUP
    MARK_READY_FOR_PICKUP_SUCCESS
    MARK_READY_FOR_PICKUP_FAILURE
    GET_READY_FOR_PICKUP
    GET_READY_FOR_PICKUP_SUCCESS
    GET_READY_FOR_PICKUP_FAILURE
    UPDATE_PICKLIST_QTY
    UPDATE_PICKLIST_QTY_SUCCESS
    UPDATE_PICKLIST_QTY_FAILURE
    GET_STOCKS_COUNT
    GET_STOCKS_COUNT_SUCCESS
    GET_STOCKS_COUNT_FAILURE
    GET_SALES
    GET_SALES_SUCCESS
    GET_SALES_FAILURE
    GET_SALES_ITEM_DETAILS
    GET_SALES_ITEM_DETAILS_SUCCESS
    GET_SALES_ITEM_DETAILS_FAILURE
    MARK_OUT_OF_STOCK
    MARK_OUT_OF_STOCK_SUCCESS
    MARK_OUT_OF_STOCK_FAILURE
    GET_NOTIFICATION_PREFERENCE
    GET_NOTIFICATION_PREFERENCE_SUCCESS
    GET_NOTIFICATION_PREFERENCE_FAILURE
    POST_PREFERENCE
    POST_PREFERENCE_SUCCESS
    POST_PREFERENCE_FAILURE

    SEARCH_DISPUTE_ASN_RTV
    SEARCH_DISPUTE_ASN_RTV_SUCCESS
    SEARCH_DISPUTE_ASN_RTV_FAILURE
    CREATE_DISPUTE
    CREATE_DISPUTE_SUCCESS
    CREATE_DISPUTE_FAILURE

    LIST_DISPUTES
    LIST_DISPUTES_SUCCESS
    LIST_DISPUTES_FAILURE

    RETRIEVE_SLOTS
    RETRIEVE_SLOTS_SUCCESS
    RETRIEVE_SLOTS_FAILURE

    LIST_DISPUTE_REASONS
    LIST_DISPUTE_REASONS_SUCCESS
    LIST_DISPUTE_REASONS_FAILURE

    GET_INVENTORY_WAREHOUSE
    GET_INVENTORY_WAREHOUSE_SUCCESS
    GET_INVENTORY_WAREHOUSE_FAILURE

    GET_FBN_SETTINGS
    GET_FBN_SETTINGS_SUCCESS
    GET_FBN_SETTINGS_FAILURE

    CHANGE_FBN_SETTINGS
    CHANGE_FBN_SETTINGS_SUCCESS
    CHANGE_FBN_SETTINGS_FAILURE

    GET_STATUS
    GET_STATUS_SUCCESS
    GET_STATUS_FAILURE

    GET_SALES_STATUS
    GET_SALES_STATUS_SUCCESS
    GET_SALES_STATUS_FAILURE

    GET_RTV_STATUS
    GET_RTV_STATUS_SUCCESS
    GET_RTV_STATUS_FAILURE

    GET_ASN_BATCHES_STOCK
    GET_ASN_BATCHES_STOCK_SUCCESS
    GET_ASN_BATCHES_STOCK_FAILURE
    GET_IMPORT_LINES
    GET_IMPORT_LINES_SUCCESS
    GET_IMPORT_LINES_FAILURE
    GET_STOCK_LINES
    GET_STOCK_LINES_SUCCESS
    GET_STOCK_LINES_FAILURE
    EXPORT_STOCK
    EXPORT_STOCK_SUCCESS
    EXPORT_STOCK_FAILURE
    IMPORT_STOCK
    IMPORT_STOCK_SUCCESS
    IMPORT_STOCK_FAILURE
`);



// WEBPACK FOOTER //
// ./src/actions/Types.js